export default __webpack_public_path__ + "static/media/member.c4f52efd.svg";